export default __webpack_public_path__ + "static/media/me.15e5c533.PNG";